var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('handle-guest-form',{attrs:{"jinroRoom":_vm.jinroRoom,"buttonType":"is-primary","buttonLabel":"ゲストとして人狼に参加する","isRedirectAfterAdded":_vm.isRedirectAfterAdded,"isPublicViewingButtonAllowed":true}})}
var staticRenderFns = []

export { render, staticRenderFns }